import { useChannelStore } from '@entities/channel'
import { usePartners } from '@entities/partner'
import type { FormProps } from 'antd'
import { Button, Col, Form, Input, Row } from 'antd'
import InputMask from 'react-input-mask'
import { useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'

type MainFormFields = {
    name: string
    tgUsername: string
    email: string
    phone: string
    comment: string
    relatedChannel: number
}

export const MainForm = () => {
    const {
        actions: { createPartner }
    } = usePartners()

    const { currentChannel } = useChannelStore(useShallow(({ current }) => ({ currentChannel: current })))

    const navigate = useNavigate()

    const onFinish: FormProps<MainFormFields>['onFinish'] = async (values) => {
        const partner = await createPartner(values)

        navigate(`/advertising/partners/${partner.id}`)
    }

    const [form] = Form.useForm()

    return (
        <Form
            form={form}
            name="add-partner"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{
                relatedChannel: currentChannel?.id
            }}
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Form.Item name="relatedChannel" hidden />
                <Col span={4}>
                    <Form.Item
                        label="Имя"
                        name="name"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="Введите имя" />
                    </Form.Item>
                </Col>
                <Col span={20}></Col>
                <Col span={4}>
                    <Form.Item
                        label="Username в телеграм"
                        name="tgUsername"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="@username" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item
                        label="E-mail"
                        name="email"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="helle@telegaplan.me" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item
                        label="Номер телефона"
                        name="phone"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <InputMask mask="+7(999)999-99-99">
                            {(inputProps) => <Input {...inputProps} placeholder="Введите номер телефона" />}
                        </InputMask>
                    </Form.Item>
                </Col>
                <Col span={12}></Col>
                <Col span={4}>
                    <Form.Item label="Комментарий" name="comment" required={false}>
                        <Input.TextArea placeholder="Введите текст" />
                    </Form.Item>
                </Col>
                <Col span={20}></Col>
                <Col span={4}>
                    <Button type="primary" htmlType="submit" disabled={false}>
                        Сохранить
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}
